var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header'),_c('div',{staticClass:"nodata"},[_c('img',{staticClass:"nodata-icon",attrs:{"src":require('@/assets/nodata.png')}}),_c('div',{staticClass:"nodata-text"},[_vm._v("您还没有登录，请先登录汽车之家招聘系统")]),_c('van-button',{staticClass:"nodata-btn",on:{"click":_vm.onLogin}},[_vm._v(" 登录 ")])],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }